import { getLocStore } from ".";
import { LocContext } from "./LocContext";

/**
 * Translates error messages from both the next api and the bff backend.
 *
 * Run npm run generate-translation-sources after adding new messages
 */
export function translateErrorMessageFromBackend(_message: string): any {
  const L = getLocStore(LocContext.ERROR);

  const { message, values } = extractBrackets(_message);

  if (message === "Test error {0}. One more interpolated value: {1}") {
    const x = L.id("e2ffd0333fad").split(
      "Testfeil {0}. Enda en interpolert verdi: {1}",
      values
    );

    return x;
  }

  if (message === "e18211d0386c") {
    // TimesheetAlreadyExported
    return L.id("0d2b0c506e7d").loc("Timelisten er allerede eksportert");
  }

  if (message === "Invalid or expired token") {
    return L.id("761d595b0b4d").loc("Ugyldig eller utløpt token");
  }

  if (message === "This profile is already connected.") {
    return L.id("2948f8d24df0").loc("Denne profilen er allerede tilkoblet.");
  }

  if (message === "A user is already connected for {0}.") {
    return L.id("0339a3c3141e").split(
      "En profil er allerede tilkoblet for {0}.",
      values
    );
  }

  if (message === "En eller flere obligatoriske parametre er ubalansert") {
    return L.id("fbd6eee858a4").loc(
      "En eller flere obligatoriske parametre er ubalansert"
    );
  }

  if (message === "NO NEXT TOKEN") {
    return L.id("13179558cc52").loc("Uautorisert - ingen next token");
  }

  if (message === "MISSING ID_CONCERN") {
    return L.id("76c44cb117da").loc("Mangler konsern ID");
  }

  if (message === "INTERNAL OPERATION") {
    return L.id("5f05708fbc5a").loc("Intern operasjon");
  }

  // SERVICE_UNAVAILABLE_MESSAGE in api/nextApiHelpers.ts: 502/503/504, where
  // the body is a proxy error page and not a message
  if (message === "Service temporarily unavailable") {
    return L.id("7c2e4b9a1d36").loc(
      "Tjenesten er midlertidig utilgjengelig. Prøv igjen om litt."
    );
  }

  // interpolate the values back into the message
  if (values.length) {
    return message.replace(/{[^}]+}/g, () => values.shift() || "");
  }

  return message;
}

function extractBrackets(s: string) {
  // replace "test {a} test abc {b} {c}" with "test {0} test abc {1} {2}" and extract the strings in the brackets

  let bracketCounter = 0;
  const bracketMap = new Map<string, string>();
  const message = ((s || "") + "").replace(/{[^}]+}/g, (match) => {
    const key = `{${bracketCounter++}}`;
    bracketMap.set(key, match.slice(1, -1));
    return key;
  });

  return { message, values: [...bracketMap.values()] };
}
